<script setup lang="ts">
import { titleBar } from '@/composables/menu/title'
import { useI18n } from 'vue-i18n'
import { CODE_OK } from '@/apis/code'
import { getFamilyNames, type FamilyNameDTO } from '@/composables/memorize/memorize'

const { t } = useI18n()
const route = useRoute()
const requestURL = useRequestURL()

const canonicalUrl = computed(() => `${requestURL.origin}${route.path}`)
const pageTitle = computed(() => '姓氏纪念馆列表')
const pageDescription = computed(() => '按姓氏分类的纪念馆列表')

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: pageDescription,
  ogDescription: pageDescription,
  ogUrl: canonicalUrl,
  twitterCard: 'summary_large_image'
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl
    }
  ]
})

onMounted(() => {
  titleBar.value.hideBack = false
  titleBar.value.backable = true
  titleBar.value.transparent = false
  titleBar.value.title = '姓氏纪念馆列表'
})

const nuxtApp = useNuxtApp() as any
if (!nuxtApp.payload.data) {
  nuxtApp.payload.data = {}
}
if (nuxtApp.static && !nuxtApp.static.data) {
  nuxtApp.static.data = {}
}

const familyNameList = useState<FamilyNameDTO[]>('family-name-list', () => [])

const { data: ssrData } = await useAsyncData('family-name-list-data', async () => {
  const { data } = await getFamilyNames()
  return data.value
})

watch(
  () => ssrData.value,
  (value) => {
    if (value && value.code === CODE_OK) {
      familyNameList.value = (value.data as FamilyNameDTO[]) ?? []
    }
  },
  { immediate: true }
)
</script>

<template>
  <BaseLayout>
    <OpenListLayout title="姓氏纪念馆列表">
      <div v-if="familyNameList.length === 0" class="text-center text-gray-400 py-8">
        {{ t('message.no_data') }}
      </div>
      <OpenListItem
        v-for="(stat, index) in familyNameList"
        :key="index"
        :to="`/memorial/familyName/${encodeURIComponent(stat.familyName)}`"
        :label="stat.familyName"
        :count="stat.count" />
    </OpenListLayout>
  </BaseLayout>
</template>
